import React, { useEffect } from "react";
import s from "./EventDetails.module.scss";
import Header from "../../components/Header/Header";
import Footer from "../../components/Footer/Footer";
import { useParams } from "react-router-dom";
import useWindowDimensions from "../../components/WindowDimensions/WindowDimensions";
import MobileHeader from "../../components/MobileHeader/MobileHeader";
import ScrollToTop from "../../components/ScrollToTop/ScrollToTop";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { getEventDetails, getNewsDetails } from "../../redux/ApplicationSlice";
import { Carousel } from "react-responsive-carousel";
import moment from "moment/moment";
import { CalendarOutlined, EnvironmentOutlined } from "@ant-design/icons";

const EventDetails = () => {
  const { width } = useWindowDimensions();
  // const news = data.find(it => it.id === Number(params.id))
  const event = useSelector((state) => state.application.eventDetails);
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const params = useParams();

  const styleObj = {
    lineHeight: 4,
    lineSpacingMultiplier: "2",
    letterSpacing: "1px",
  };

  useEffect(() => {
    dispatch(getEventDetails(Number(params.id)));
  }, [dispatch, params.id]);

  return (
    <div className={s.news_details}>
      {width > 970 ? <Header /> : <MobileHeader />}
      <div className={s.news_content}>
        <Carousel
          showThumbs={true}
          showStatus={false}
          autoPlay={true}
          thumbWidth={120}
          thumbHeight={40}
          className="news-carousel"
        >
          {event?.photos?.map((it) => (
            <div>
              <img src={it.image} className={s.img} />
            </div>
          ))}
        </Carousel>
        <div className={s.news_date}>{event?.created_at}</div>

        <div className={s.news_category}>{t("мероприятия").toUpperCase()}</div>
        <div className={s.news_title}>{event?.title}</div>
        <div className={s.event_header}>
          <div className={s.date}>
            <CalendarOutlined />{" "}
            {moment(event?.event_date).format("DD.MM.YYYY")}
          </div>
          <div className={s.location}>
            {" "}
            <EnvironmentOutlined /> {event?.event_location}
          </div>
        </div>

        <div
          className={s.news_description}
          dangerouslySetInnerHTML={{ __html: event?.description }}
          style={styleObj}
        ></div>
      </div>
      <Footer />
      <ScrollToTop />
    </div>
  );
};

export default EventDetails;
